import {SingleStar} from "@components/elements/SingleStar";
import React from "react";

export function StarRating(props: { rating: number, className?: string, maxRating: number, starSizeClassName?: string }) {
    return <div className={[props.className, "flex items-center justify-center",].join(' ')}
                title={props.rating.toString() + " out of " + props.maxRating}>
        <div className="flex items-center">
            {[...Array(props.maxRating)].map((_, i) => <SingleStar
                key={i}
                index={i}
                precision={0.25}
                starSizeClassName={props.starSizeClassName}
                percentage={Math.min(1, Math.max(0, props.rating - i)) * 100}
            />)}
        </div>
    </div>;
}
